import React, { useMemo } from 'react';
import _keyBy from 'lodash/keyBy';
import { FormValue } from 'types/FormValue';
import * as Sift from '@sift/types';
import * as Types from 'pages/General/typings';
import { highlightByFilter } from 'pages/Features/tabs/OrgChart/OrgChartHighlightsLayout';

// Components
import LayoutSettingCard from 'molecules/LayoutSettingCard';

interface Props {
  onChange: (field: any, value: FormValue) => void;
  userStatus: number;
  fields: Sift.Field[];
  values: Types.GeneralValues;
}

function OrgLevelsLayout({ userStatus, fields, onChange, values }: Props) {
  const SUBTITLE_COPY =
    'Define which attributes represent your organization levels and their order based on descending size (e.g. Company → Department → Team). This will impact your profile pages and org chart card customization.';
  const keyedFields = useMemo(() => _keyBy(fields, 'objectKey'), [fields]);

  return (
    <LayoutSettingCard
      cardTitle="Organization Levels"
      dialogTitle="Configure Org Levels"
      filter={field => highlightByFilter(field, fields)}
      layoutKey="org-levels"
      subtitle={SUBTITLE_COPY}
      userStatus={userStatus}
      fields={keyedFields}
      onChange={onChange}
      values={values}
      typeKey="user"
    />
  );
}

export default OrgLevelsLayout;
